// third-party
import { combineReducers } from 'redux';

// theme native reducers
import mainReducer from './slices/main';
import breadCrumbsReducer from './slices/breadcrumbs';
import snackbarReducer from './slices/snackbar';
import confirmDialogReducer from './slices/confirm-dialog';

// admin reducers
import codeGeneratorSettingsReducer from './app/admin/codegenerator-settings';
import groupReducer from './app/admin/group';
import userReducer from './app/admin/user';
import notificationReducer from './app/admin/notification';

// common reducers
import departmentReducer from './app/common/department';
import employeeReducer from './app/common/employee';

// crm reducers
import clientReducer from './app/crm/client';
import contractReducer from './app/crm/contract';
import contractTypeReducer from './app/crm/contract-type';
import partnershipTypeReducer from './app/crm/partnership-type';

// template management reducers
import tplBusinessOpportunityReducer from './app/tplmgmt/busopp';
import tplWorkOrderReducer from './app/tplmgmt/workorder';
import tplTaskReducer from './app/tplmgmt/task';
import tplFollowUpReducer from './app/tplmgmt/followup';
import tplFollowUpStepReducer from './app/tplmgmt/followup-step';

// work management reducers
import businessOpportunityTypeReducer from './app/workmgmt/busopp-type';
import workOrderTypeReducer from './app/workmgmt/workorder-type';
import followUpReducer from './app/workmgmt/followup';
import followUpStepReducer from './app/workmgmt/followup-step';
import ticketTypeReducer from './app/workmgmt/ticket-type';
import businessOpportunityReducer from './app/workmgmt/busopp';
import workOrderReducer from './app/workmgmt/workorder';
import taskReducer from './app/workmgmt/task';
import ticketReducer from './app/workmgmt/ticket';

// log reducers
import logBusinessOpportunityArchiveReducer from './app/log/busopp-archive';
import logWorkOrderArchiveReducer from './app/log/workorder-archive';
import logOperationReducer from './app/log/operation';
import logCommandExecutionReducer from './app/log/command-execution';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    main: mainReducer,
    breadCrumbs: breadCrumbsReducer,
    confirmDialog: confirmDialogReducer,
    //---------------------------------
    codeGeneratorSettings: codeGeneratorSettingsReducer,
    group: groupReducer,
    user: userReducer,
    notification: notificationReducer,
    //---------------------------------
    department: departmentReducer,
    employee: employeeReducer,
    //---------------------------------
    client: clientReducer,
    contract: contractReducer,
    contractType: contractTypeReducer,
    partnershipType: partnershipTypeReducer,
    //---------------------------------
    tplBusinessOpportunity: tplBusinessOpportunityReducer,
    tplWorkOrder: tplWorkOrderReducer,
    tplTask: tplTaskReducer,
    tplFollowUp: tplFollowUpReducer,
    tplFollowUpStep: tplFollowUpStepReducer,
    //---------------------------------
    businessOpportunityType: businessOpportunityTypeReducer,
    workOrderType: workOrderTypeReducer,
    followUp: followUpReducer,
    followUpStep: followUpStepReducer,
    ticketType: ticketTypeReducer,
    businessOpportunity: businessOpportunityReducer,
    workOrder: workOrderReducer,
    task: taskReducer,
    ticket: ticketReducer,
    //---------------------------------
    businessOpportunityArchive: logBusinessOpportunityArchiveReducer,
    workOrderArchive: logWorkOrderArchiveReducer,
    logOperation: logOperationReducer,
    commandExecution: logCommandExecutionReducer
});

export default reducer;
